// extracted by mini-css-extract-plugin
export var locationCard = "_ij-0";